import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import BottomAccordion from '../../../shared/bottom-accordion/content';
import HtmlToReact from 'html-to-react';
import xss from 'xss';

let htmlToReactParser = new HtmlToReact.Parser(React);

export default function Accordion(props) {
  const aboutThisPageMarkup = (
    <div>
      <i className="ui icon info circle mrls mrrnull text-size-xl fr mrbs" />
      <p>
        {htmlToReactParser.parse(
          xss(
            props.organisationalUnit && props.organisationalUnit.name
              ? APP.LANGUAGE.OrganisationalUnitManageUsers.InfoPartOne.replace(
                  '##organisationalUnitName##',
                  props.organisationalUnit.name
                )
              : ''
          )
        )}
      </p>
    </div>
  );
  const options = [
    {
      title: 'About this page',
      as: 'custom',
      content: aboutThisPageMarkup,
    },
  ];
  const activeIndexOfPage = window.localStorage.getItem(`orgUsersActiveIndex-${props.userId}`);
  return (
    <BottomAccordion
      options={options}
      userId={props.userId}
      pagePrefix="orgUsersActiveIndex"
      activeIndex={
        (!!activeIndexOfPage && JSON.parse(activeIndexOfPage)) || [
          options[options.length - 1].title.split(' ').join(''),
        ]
      }
    />
  );
}
